import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-white text-gray-800 rounded-lg relative shadow-lg`}
  border: 1px solid #e0e0e0;
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
    text-align: center; /* Centrar el título */
  }
  input, textarea {
    ${tw`w-full bg-transparent text-gray-800 text-base font-medium tracking-wide border-b-2 py-2 hocus:border-red-400 focus:outline-none transition duration-200`};
    border-color: #cbd5e0; /* Color inicial del borde */
    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm text-gray-700`;
const Input = styled.input`
  ${tw`border-b-2 border-transparent focus:border-red-400 transition duration-200`};
  padding-left: 10px; /* Espacio adicional a la izquierda */
`;
const TextArea = styled.textarea`
  ${tw`border-b-2 border-transparent focus:border-red-400 transition duration-200`};
  padding-left: 10px; /* Espacio adicional a la izquierda */
  resize: none; /* Deshabilitar el redimensionamiento */
`;
const SubmitButton = styled.button`
  ${tw`w-full sm:w-32 mt-6 py-3 bg-red-500 text-white rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-red-600 hocus:-translate-y-px hocus:shadow-xl`}
  border: none; /* Quitar el borde */
  outline: none; /* Quitar el contorno */
`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`;

export default () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const whatsappNumber = '+595981346154'; // Reemplaza con el número de WhatsApp deseado
    const whatsappMessage = `Nombre: ${name}\nEmail: ${email}\nMensaje: ${message}`;
    const whatsappURL = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappURL, '_blank');
  };

  return (
    <Container>
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl">
            <h2>Contrataciones</h2>
            <form onSubmit={handleSubmit}>
              <TwoColumn>
                <Column>
                  <InputContainer>
                    <Label htmlFor="name-input">Nombre</Label>
                    <Input
                      id="name-input"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </InputContainer>
                  <InputContainer>
                    <Label htmlFor="email-input">Email</Label>
                    <Input
                      id="email-input"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </InputContainer>
                </Column>
                <Column>
                  <InputContainer tw="flex-1">
                    <Label htmlFor="message-input">Mensaje</Label>
                    <TextArea
                      id="message-input"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                    />
                  </InputContainer>
                </Column>
              </TwoColumn>
              <SubmitButton type="submit">Enviar</SubmitButton>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
